export default function Conditional() {
  return (
    <table className="table_sticky">
      <tbody>
        <tr>
          <th>
            <em>infinitive</em>
          </th>
          <td>
            <center> dělati </center>
          </td>
        </tr>
        <tr colSpan={2}>
          <th>
            <em>infinitive stem</em>
          </th>
          <td colSpan={2}>
            <b>
              <center> děla- </center>
            </b>
          </td>
        </tr>
        <tr>
          <th> ja </th>
          <td> byh dělal(a) </td>
        </tr>
        <tr>
          <th> ty </th>
          <td> bys dělal(a) </td>
        </tr>
        <tr>
          <th>
            on <br /> ona <br /> ono
          </th>
          <td>
            by dělal <br /> by dělala <br /> by dělalo
          </td>
        </tr>
        <tr>
          <th> my </th>
          <td> byhmo dělali </td>
        </tr>
        <tr>
          <th> vy </th>
          <td> byste dělali </td>
        </tr>
        <tr>
          <th> oni/one </th>
          <td> by dělali </td>
        </tr>
      </tbody>
    </table>
  )
}
